export class ShiftWork {
    typeShiftWork = null;
    startTime = null;
    endTime = null;
    title = null;
    parentId = null;
}